var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRightArrowPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:arrow-sort-up-24-regular"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.75958 11.8535L12.849 8.85671C12.9363 8.77203 12.9894 8.65976 12.9986 8.54033C13.0078 8.42089 12.9725 8.30221 12.8992 8.20588L12.8497 8.14919L9.76027 5.14576C9.66828 5.05688 9.54512 5.00494 9.41538 5.00034C9.28565 4.99573 9.1589 5.03878 9.06046 5.1209C8.96202 5.20302 8.89915 5.31815 8.88439 5.44329C8.86964 5.56843 8.90409 5.69436 8.98087 5.79593L9.03036 5.85194L11.2414 8.00116H2.51547C2.39091 8.00116 2.27056 8.04493 2.17668 8.12437C2.08281 8.2038 2.02175 8.31353 2.00481 8.43327L2 8.50062C2 8.62147 2.04512 8.73824 2.12699 8.82932C2.20886 8.9204 2.32196 8.97964 2.44537 8.99608L2.51547 9.00074L11.2428 9.00141L9.03105 11.1466C8.94375 11.2313 8.89067 11.3436 8.88146 11.463C8.87225 11.5824 8.90753 11.7011 8.98087 11.7975L9.03105 11.8535C9.11832 11.9382 9.23403 11.9897 9.35713 11.9986C9.48024 12.0075 9.60255 11.9733 9.70185 11.9022L9.75958 11.8535Z",
    fill: "#5A8DF1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRightArrowPrimary);
export default __webpack_public_path__ + "static/media/ic_right_arrow_primary.261ed89d42677b680895f4220a872174.svg";
export { ForwardRef as ReactComponent };